import { useOwnerSpecificStaffDesignation } from "repositories/scheduler-repository";
import SidebarCheckbox from "./SidebarCheckbox";
import { useCallback, useEffect, useMemo, useState } from "react";

const SidebarStaffRoleFilter = ({
  selectedId,
  allFiltersRef,
  resetFilters,
  preSetter,
}) => {
  const [multiSelection, setMultiSelection] = useState(preSetter || []);
  const { data } = useOwnerSpecificStaffDesignation(
    { selectedId },
    { enabled: !!selectedId }
  );
  const dataTobeRender = useMemo(() => {
    return data?.designations_list || [];
  }, [data]);
  
  const handleChange = useCallback((e, item) => {
    setMultiSelection((prev) => {
      if (e.target.checked) {
        return [...prev, item.id];
      }
      return prev.filter((res) => res !== item.id);
    });
  }, []);
  useEffect(() => {
    const designationIdsArray = allFiltersRef.current?.designationIds;
    if (designationIdsArray) {
      allFiltersRef.current.designationIds = multiSelection;
    }
  }, [multiSelection]);
  useEffect(() => {
    if (resetFilters) {
      setMultiSelection([]);
    }
  }, [resetFilters]);
  return (
    <SidebarCheckbox
      checked={({ id }) => multiSelection.includes(id)}
      handleChange={handleChange}
      data={dataTobeRender}
      renderName={(res) => res.name}
    />
  );
};
export default SidebarStaffRoleFilter;
